import { render } from "./ApproveView.vue?vue&type=template&id=4f41227a&scoped=true"
import script from "./ApproveView.vue?vue&type=script&lang=js"
export * from "./ApproveView.vue?vue&type=script&lang=js"

import "./ApproveView.vue?vue&type=style&index=0&id=4f41227a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f41227a"]])

export default __exports__